function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-1_svg__a",
  x1: 247.87,
  x2: 247.87,
  y1: 522.59,
  y2: -178.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cb3974"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff92ba"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__c",
  x1: -155.71,
  x2: 475.47,
  y1: 270.72,
  y2: 270.72
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__d",
  x1: 16523.48,
  x2: 17448.94,
  y1: 15000.44,
  y2: 15000.44,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__e",
  x1: 16523.48,
  x2: 17448.94,
  y1: 14720.09,
  y2: 14720.09,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__f",
  x1: 16523.48,
  x2: 17448.94,
  y1: 14716.2,
  y2: 14716.2,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__g",
  x1: 16614.6,
  x2: 17397.56,
  y1: 14697.91,
  y2: 14697.91,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__h",
  x1: 16523.48,
  x2: 17448.94,
  y1: 14697.91,
  y2: 14697.91,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__i",
  x1: 16614.6,
  x2: 17397.56,
  y1: 14695.77,
  y2: 14695.77,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__j",
  x1: 16523.48,
  x2: 17448.94,
  y1: 14695.77,
  y2: 14695.77,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__k",
  x1: 16523.48,
  x2: 17448.94,
  y1: 14910.47,
  y2: 14910.47,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__l",
  x1: 16614.6,
  x2: 17397.56,
  y1: 14779.77,
  y2: 14779.77,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__a",
  id: "loyalty-tier-1_svg__m",
  x1: 16523.48,
  x2: 17448.94,
  y1: 14779.77,
  y2: 14779.77,
  gradientTransform: "rotate(180 8681.55 7529.865)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "loyalty-tier-1_svg__b",
  x1: 192.47,
  x2: 334.54,
  y1: 133.23,
  y2: 205.46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e3fffa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#9eefe1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__b",
  id: "loyalty-tier-1_svg__n",
  x1: 223.61,
  x2: 278.66,
  y1: 241.41,
  y2: 241.41
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__b",
  id: "loyalty-tier-1_svg__o",
  x1: 260.52,
  x2: 297.39,
  y1: 337.09,
  y2: 337.09
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__b",
  id: "loyalty-tier-1_svg__p",
  x1: 260.52,
  x2: 288.28,
  y1: 369.5,
  y2: 369.5
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__b",
  id: "loyalty-tier-1_svg__q",
  x1: 230.45,
  x2: 271.82,
  y1: 261.23,
  y2: 261.23
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#loyalty-tier-1_svg__b",
  id: "loyalty-tier-1_svg__r",
  x1: 251.13,
  x2: 251.13,
  y1: 214.1,
  y2: 110.42
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M435.41 520.6l-178.7-83.74a20.84 20.84 0 00-17.67 0L60.33 520.6C46.7 527 31 517.2 31 502.33V50.56a20.4 20.4 0 0120.5-20.24h392.74a20.4 20.4 0 0120.56 20.24v451.77c0 14.87-15.75 24.67-29.39 18.27z",
  fill: "url(#loyalty-tier-1_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M416.11 487.07l-160.31-76.3a18.49 18.49 0 00-15.85 0l-160.31 76.3a18.44 18.44 0 01-26.36-16.64V71a18.44 18.44 0 0118.44-18.44H424A18.43 18.43 0 01442.46 71v399.43a18.43 18.43 0 01-26.35 16.64z",
  fill: "url(#loyalty-tier-1_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M353.61 161.87a102.06 102.06 0 01-8.24 40.26l45.16 95 51.93 109.2V71A18.43 18.43 0 00424 52.56H274.23l5.16 10.84a102.44 102.44 0 0174.22 98.47zM105.21 297.1l48.87-102.75A102.48 102.48 0 01215.11 66l6.4-13.47H71.72A18.44 18.44 0 0053.28 71v335.3z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.21 59.47a102.36 102.36 0 0128.18 3.93l-5.16-10.84h-52.72L215.11 66a102 102 0 0136.1-6.53z",
  fill: "url(#loyalty-tier-1_svg__d)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.34 234.75a102.36 102.36 0 01-25.26-40.4L105.21 297.1 53.28 406.3v64.13a18.22 18.22 0 007.07 14.5l66.83-140.51z",
  fill: "url(#loyalty-tier-1_svg__e)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.37 202.13A102.7 102.7 0 01318.45 239l50.11 105.38 66.83 140.51a18.22 18.22 0 007.07-14.5V406.3l-51.93-109.2z",
  fill: "url(#loyalty-tier-1_svg__f)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M196 248.1a103.37 103.37 0 01-16.68-13.35l-52.14 109.67-66.83 140.51a18.31 18.31 0 0019.29 2.14L132.38 462l56.37-190.38z",
  fill: "url(#loyalty-tier-1_svg__g)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M196 248.1a103.37 103.37 0 01-16.68-13.35l-52.14 109.67-66.83 140.51a18.31 18.31 0 0019.29 2.14L132.38 462l56.37-190.38z",
  fill: "url(#loyalty-tier-1_svg__h)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M318.45 239a102.52 102.52 0 01-12.05 9.06l7.27 23.49 65 197.68 37.4 17.8a18.29 18.29 0 0019.28-2.14l-66.79-140.47z",
  fill: "url(#loyalty-tier-1_svg__i)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M318.45 239a102.52 102.52 0 01-12.05 9.06l7.27 23.49 65 197.68 37.4 17.8a18.29 18.29 0 0019.28-2.14l-66.79-140.47z",
  fill: "url(#loyalty-tier-1_svg__j)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.34 234.75l68.53-144.11L318.45 239a102.7 102.7 0 0026.92-36.91l-66-138.73A102.78 102.78 0 00215.11 66l-61 128.32a102.36 102.36 0 0025.23 40.43z",
  fill: "url(#loyalty-tier-1_svg__k)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.4 248.1a102.52 102.52 0 0012.05-9.1L247.87 90.64l-68.53 144.11A103.37 103.37 0 00196 248.1l-7.27 23.49L132.38 462 240 410.77a18.49 18.49 0 0115.85 0l122.91 58.5-65-197.68z",
  fill: "url(#loyalty-tier-1_svg__l)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.4 248.1a102.52 102.52 0 0012.05-9.1L247.87 90.64l-68.53 144.11A103.37 103.37 0 00196 248.1l-7.27 23.49L132.38 462 240 410.77a18.49 18.49 0 0115.85 0l122.91 58.5-65-197.68z",
  fill: "url(#loyalty-tier-1_svg__m)",
  opacity: 0.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M313.67 271.59l-7.27-23.49a102.23 102.23 0 10-110.38 0l-7.27 23.49L132.38 462 240 410.77a18.49 18.49 0 0115.85 0l122.91 58.5z",
  fill: "#cb3974",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.89 127.27l-14-3.19a5.71 5.71 0 01-.43-11l13.7-4.26a5.73 5.73 0 003.88-4.19l3.19-14a5.72 5.72 0 0111-.42l4.26 13.69a5.7 5.7 0 004.18 3.88l14 3.19a5.72 5.72 0 01.42 11l-13.7 4.26a5.72 5.72 0 00-3.87 4.19l-3.2 14a5.72 5.72 0 01-11 .43l-4.25-13.7a5.73 5.73 0 00-4.18-3.88zm-294.76 0l-14-3.19a5.72 5.72 0 01-.43-11l13.7-4.26a5.73 5.73 0 003.88-4.19l3.19-14a5.72 5.72 0 0111-.42l4.26 13.69a5.72 5.72 0 004.19 3.88L128 111a5.72 5.72 0 01.42 11l-13.69 4.26a5.72 5.72 0 00-3.88 4.19l-3.19 14a5.72 5.72 0 01-11 .43l-4.25-13.7a5.73 5.73 0 00-4.28-3.91z",
  fill: "#ffb7d1",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 251.13,
  cy: 114.22,
  r: 28.8,
  stroke: "#9eefe1",
  strokeMiterlimit: 10,
  strokeWidth: 12.95,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.68 406.84a3.15 3.15 0 01-5.1 0l-7.28-8.91a12.34 12.34 0 01-2.1-3.22 15.36 15.36 0 01-.7-5.61v-193c0-5.55 0-11 2.95-15.49 2.54-3.87 6.59-6.16 10.62-5.78 4.59.44 8.86 4.34 10.55 9.65 1.15 3.59 1.16 7.56 1.16 11.42v194.08a13.47 13.47 0 01-.49 4.41 10.88 10.88 0 01-2 3.23z",
  fill: "#e3fffa"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.51 390.81l5.22 8.25a.5.5 0 00.92-.26v-191a.5.5 0 00-.08-.27l-5.22-8.25a.5.5 0 00-.92.26v191a.53.53 0 00.08.27z",
  fill: "#9eefe1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.93 137c-5.06-24.15-28.67-36.75-51-30.91-11.44 3-18.7 10.37-25.84 19a2.31 2.31 0 01-3.61-.06c-2.16-2.79-5.91-6.8-6.41-7.28-13.38-12.79-28.88-16.52-46.3-10-15.1 5.67-24.62 19.91-25.27 36.13a85.15 85.15 0 00.89 16 59.53 59.53 0 006.08 19.12 78.77 78.77 0 0013.63 18c6.94 7.14 14.49 13.63 22 20.14 6.1 5.28 12.19 10.57 18.22 15.93 5.08 4.51 9.79 10.16 16.88 11.29 9.22 1.46 15.31-6.46 21.42-11.89 9.35-8.3 18.84-16.45 28.22-24.73a157.34 157.34 0 0016.92-16.94 60.49 60.49 0 0012.84-24.56 80.52 80.52 0 002.16-16.93 52.32 52.32 0 00-.83-12.31z",
  fill: "url(#loyalty-tier-1_svg__b)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 55.05,
  height: 21.37,
  x: 223.61,
  y: 230.72,
  rx: 5.06,
  fill: "url(#loyalty-tier-1_svg__n)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M286.44 346.39h-25.92v-18.6h34.4a2.47 2.47 0 012.1 3.77l-8.48 13.66a2.48 2.48 0 01-2.1 1.17z",
  fill: "url(#loyalty-tier-1_svg__o)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.33 378.8h-16.81v-18.6h25.29a2.48 2.48 0 012.1 3.78l-8.48 13.65a2.46 2.46 0 01-2.1 1.17z",
  fill: "url(#loyalty-tier-1_svg__p)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271 253.31a3.35 3.35 0 00-2.57-1.22h-34.62a3.39 3.39 0 00-2.57 1.22 3.34 3.34 0 00-.79 2.15V267a3.35 3.35 0 003.36 3.36h34.64a3.36 3.36 0 003.37-3.36v-11.54a3.35 3.35 0 00-.82-2.15z",
  fill: "url(#loyalty-tier-1_svg__q)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M268.45 252.09h-34.64a3.39 3.39 0 00-2.57 1.22H271a3.35 3.35 0 00-2.55-1.22z",
  fill: "#1c988a",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 251.13,
  cy: 174.58,
  r: 39.52,
  fill: "url(#loyalty-tier-1_svg__r)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224 174.58a27.17 27.17 0 0027.17 27.17v-54.34A27.18 27.18 0 00224 174.58z",
  fill: "#bf8ce0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.13 147.41v54.34a27.17 27.17 0 100-54.34z",
  fill: "#cca1e5"
})));

function SvgLoyaltyTier1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 514 572"
  }, props), _ref, _ref2);
}

export default SvgLoyaltyTier1;